// load scss
import './Main.scss';

// load js
import 'bootstrap';
import '../JavaScript';
